(() => {
    /**
     * This code loads the content from on page components and updates the JSON-LD
     * generated by the server side JS in <head> tag. In https://www.gtlaw.com.au/_admin/?screen=contents&assetid=104
     */
    addEventListener('DOMContentLoaded', () => {
        const formatText = (text) => {
            // remove new lines and double spaces and '"'
            return text
                .replace(/\r\n|\r|\n|\t/g, ' ')
                .replace(/\s{2,}/g, ' ')
                .replace(/"/g, '\\"');
        };

        const article = document.getElementById("article-content");
        const articleJsonLd = document.getElementById("insightsJsonLd");

        if (article && articleJsonLd) {
          const content = formatText(article.children[0].children[2].innerText);
          const updated = articleJsonLd.innerHTML.replace(
            "__ARTICLE_PLACEHOLDER__",
            content
          );
          articleJsonLd.innerHTML = updated;

          // count the words in the article / updated content
          const wordCount = content.split(" ").length;
          const updateWordCount = articleJsonLd.innerHTML.replace(
            '"wordCount":0',
            `"wordCount":${wordCount}`
          );
          articleJsonLd.innerHTML = updateWordCount;
        }
    });
})();
